<button
  (click)="toggleMenu()"
  [attr.readonly]="readonly"
  type="button"
  class="color-button myre-form__field"
>
  <span [style.background-color]="value" class="color-button-box"></span>
</button>

@if (isOpen) {
  <div
    [ngClass]="[
      'dropdown-' + verticalDirection,
      'dropdown-' + horizontalDirection,
    ]"
    class="myre-dropdown-box dropdown"
  >
    <div class="colors">
      <div class="set-selector">
        @for (colorSet of colors; track colorSet; let last = $last) {
          <div
            [style.background-color]="colorSet['500']"
            [style.color]="colorSet['500']"
            [ngClass]="{ last: last, selected: selectedColorSet === colorSet }"
            (click)="selectedColorSet = colorSet"
            (keyup.enter)="selectedColorSet = colorSet"
            tabindex="0"
            class="color-box"
          ></div>
        }
      </div>

      <myre-colorpicker-list
        [colorSet]="selectedColorSet"
        [activeColors]="activeColors"
        [value]="value"
        (select)="onChange($event)"
      />
    </div>
    <label for="input" class="h3">{{
      '_library.colorpicker.personalize' | translate
    }}</label>
    <input
      [readonly]="readonly"
      [disabled]="disabled"
      (ngModelChange)="onChange($event)"
      [ngModel]="value"
      id="input"
      class="myre-form__field"
      autocomplete="off"
      maxlength="7"
      pattern="#[0-9a-fA-F]{6}"
      placeholder="#"
      required
      spellcheck="false"
      title="{{ '_library.colorpicker.notation' | translate }}"
      type="text"
    />
  </div>
}
